<template>
  <div class="dealer-select">
    <el-cascader v-loading="loading" v-model="dealerIds" :style="customStyle" :options="options"
      :show-all-levels="false" :props="cascaderProps" :disabled="disabled" filterable clearable placeholder="请选择经销商"
      @change="handleChange">
    </el-cascader>
  </div>
</template>

<script>
  import {
    getDealerList
  } from '@/api/work'

  export default {
    name: 'DealerSelect',
    props: {
      value: {
        type: [String, Number, Array],
        default: ''
      },
      groupid: {
        type: Number
      },
      userid: {
        type: Number,
        default: null
      },
      multiple: {
        type: Boolean,
        default: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      dealers: {
        type: Array,
        default: () => []
      },
      customStyle: {
        type: String,
        default: 'width: 100%'
      }
    },
    watch: {
      value(newVal) {
        this.dealerIds = newVal
      }
    },
    data() {
      return {
        dealerIds: this.value,
        loading: false,
        options: [],
        cascaderProps: {
          multiple: true,
          emitPath: false
        },
      }
    },
    created() {
      this.cascaderProps.multiple = this.multiple
      if (this.dealers && this.dealers.length > 0) {
        this.options = this.handleDealerTree(this.dealers)
      } else {
        this.loading = true
        getDealerList({
          groupid: this.groupid,
          userid: this.userid,
          page: 1,
          limit: 999
        }).then(response => {
          this.loading = false
          let data = response.data || []
          this.options = this.handleDealerTree(data)
        }).catch(() => {
          this.loading = false
        })
      }
    },
    methods: {
      handleChange(value) {
        this.$emit('input', value)
      },

      handleDealerTree(data) {
        if (!data || data.length == 0) {
          return []
        }
        const brands = [{
          id: 1,
          name: '乔金斯',
          other: '四叶草'
        }, {
          id: 3,
          name: '首造'
        }]
        let options = [];
        brands.forEach(b => {
          let children = []
          data.filter(it => it.brands && (it.brands.indexOf(b.name) > -1 ||
            (b.other && it.brands.indexOf(b.other) > -1))).forEach(it => {
            children.push({
              label: it.allname + '【' + it.brands + '】',
              value: it.delid,
              disabled: false
            });
          });
          options.push({
            label: b.name,
            value: b.id,
            children
          });
        });
        return options;
      },

    }
  }
</script>

<style lang="scss" scoped>
  .dealer-select {
    width: 100%;
  }
</style>
